module.exports = __webpack_public_path__ + "static/logo-blue-9e22ae4e7017edbcbbb90ee8a6a5e467.png";